"use strict";

exports.__esModule = true;
exports.StripeChartElement = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _StripeChartElement = require("./StripeChartElement.legacy");
var _StripeChartElement2 = require("./StripeChartElement.modern");
// Flag-gated UI: `StripeChartElement.legacy` is the component as it is on master,
// `StripeChartElement.modern` the ui-charts-update rewrite. The nearest UiDesignProvider
// (ENABLE_MODERN_UI + the screen's flag) decides which one renders.
var StripeChartElement = exports.StripeChartElement = (0, _uiSwitch.uiSwitch)(_StripeChartElement.StripeChartElement, _StripeChartElement2.StripeChartElement, "StripeChartElement");